import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import {isEmail} from "../../utils/uitls";
import {ERR_BAD_REQUEST, getData, postData} from "../../network/network";
import {User, userUtility} from "../../models/user";
import {AxiosError} from "axios";
import {Button, Image, Modal} from "react-bootstrap";
import {MDBInput} from "mdb-react-ui-kit";

export const Login = () => {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [passwordError, setPasswordError] = useState('')
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [showModal, setShowModal] = useState<boolean>(false)

    const navigate = useNavigate()

    const onButtonClick = () => {
        if (email.length === 0 || !isEmail(email)) {
            setPasswordError('email incorrect')
            return
        }
        if (password.length === 0) {
            setPasswordError('password incorrect')
            return
        }
        postData({
            url: "/api/users/login",
            data: {
                "email": email,
                "password": password
            },
            onError: (e: AxiosError) => {
                switch (e.code) {
                    case ERR_BAD_REQUEST:
                        setPasswordError("password or email is incorrect")
                        break
                    default:
                        setPasswordError("service unavailable")
                }
                setIsLoading(false)
            },
            onSuccess: (data: User) => {
                userUtility.setUserData(data)
                navigate('/')
                setIsLoading(false)
            }
        })
        setIsLoading(true)
    }
    return (
        <div className="container-fluid">
            <ForgotPasswordModal showModal={showModal} setShowModal={setShowModal} />
            <div className="vh-100 row justify-content-center align-items-center">
                <div className="col-md-9 col-lg-6 col-xl-5">
                    <Image src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.webp"
                           fluid/>
                </div>
                <div className="col-md-8 col-lg-6 col-xl-4 offset-xl-1">
                    <form>
                        <div className="form-outline mb-4">
                            <MDBInput
                                type="email"
                                className="form-control form-control-lg"
                                id="email"
                                value={email}
                                label="Enter your email here"
                                onChange={(ev: any) => setEmail(ev.target.value)}/>
                        </div>

                        <div className="form-outline mb-3">
                            <MDBInput
                                type="password"
                                className="form-control form-control-lg"
                                id="password"
                                value={password}
                                label="Enter your password here"
                                onChange={(ev: any) => setPassword(ev.target.value)}/>
                            <div className='d-flex flex-column'>
                                <label className="ms-auto text-primary" onClick={() => {
                                    setShowModal(true)
                                }}>forget password?</label>
                            </div>
                        </div>

                        <div className="text-center text-lg-start mt-4 pt-10">
                            {isLoading ?
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                : <button type="button" className="btn btn-primary btn-lg"
                                          onClick={onButtonClick}>Login</button>}
                            {passwordError.length > 0 && <label className="errorLabel ms-2 mb-2">{passwordError}</label>}
                        </div>

                    </form>
                </div>
            </div>
        </div>
    )
}


type ForgotPasswordProps = {
    showModal: boolean
    setShowModal: (show: boolean) => void
}
const ForgotPasswordModal = (props: ForgotPasswordProps) => {

    const [email, setEmail] = useState('')
    const [error, setError] = useState('')

    const onSubmitClick = () => {
        if (email.length === 0 || !isEmail(email)) {
            setError('Please enter a valid email')
            return
        }
       getData({
           url: '/api/users/forget-password',
           data: {
               email: email
           },
           onSuccess: () => {
               setError('Email has been sent')
               props.setShowModal(false)
           },
           onError: (e: AxiosError) => {
               setError(`${e?.response?.data}`)
           }
       })
    }

    return (<Modal
            show={props.showModal}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Body>
                <div className="d-flex flex-column justify-content-center">
                    <h2 className="fw-bold mb-3">Forget Password?</h2>
                    <div className="mb-3">
                        <MDBInput
                            type="email"
                            className="form-control form-control-lg"
                            id="email"
                            value={email}
                            label="Enter your email here"
                            onChange={(ev: any) => setEmail(ev.target.value)}/>
                    </div>
                    <div className="d-flex">
                        <label className='ms-auto me-2'>{error}</label>
                        <Button onClick={() => {
                            props.setShowModal(false)
                        }}>Cancel</Button>
                        <Button className='ms-2' onClick={() => {
                            onSubmitClick()
                        }}>Submit</Button>
                    </div>
                </div>

            </Modal.Body>
        </Modal>
    )
}
